import nBossConnection from 'modules/base/service/nBossConnection';

class NotificationService {
	constructor() {
		this.connection = nBossConnection.connection;
		this.CONTROL = 'notificationControl';
	}

	/**
	* @param {number} id
	* @return {Promise<Object>}
	*/
	deleteById(id) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/deleteById`, {
					id
				})
				.then(response => resolve(response.data))
				.catch(reject);
		});
	}

	/**
	* @return {Promise<Object>}
	*/
	deleteAll(id) {
		return new Promise((resolve, reject) => {
			this.connection
				.get(`/${this.CONTROL}/deleteAll`)
				.then(response => resolve(response.data))
				.catch(reject);
		});
	}

	/**
	* @return {Promise<Object>}
	*/
	getUnreadCount() {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/getUnreadCount`, {})
				.then(response => resolve(response.data))
				.catch(reject);
		});
	}

	/**
	* @param {number} id
	* @return {Promise<Object>}
	*/
	getData(id) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/getData`, {
					id
				})
				.then(response => resolve(response.data))
				.catch(reject);
		});
	}
}

export default new NotificationService();